import React, { Fragment, useEffect, useState } from "react";
import { Button, Card, Row, ListGroup } from "react-bootstrap";
import { BiRefresh } from "react-icons/bi";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getApiUserRoles,
  getLogList,
  getLogSnippet,
} from "../../Utils/actions";
import { useTranslation } from "react-i18next";
import "./LogList.scss";
import { Box, Paper, Tooltip, IconButton } from "@material-ui/core";
import { headerLogList } from "../Common/headerName";
import { loadingOn } from "../../Utils/utils";
import DownloadIcon from "@mui/icons-material/Download";

const LogList = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { logSnippet, logFiles } = useSelector((state) => state.data);
  const [render, setRender] = useState("info");

  useEffect(() => {
    if (logSnippet?.length === 0) {
      dispatch(getLogSnippet(100));
    }
  }, []);

  useEffect(() => {
    dispatch(getApiUserRoles(sessionStorage.getItem("username")));
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      dispatch(loadingOn());
      dispatch(getLogSnippet(100));
      // dispatch(getConnectionStatus());
      // dispatch(getClusterData());
      // dispatch(getLogSnippet(100, false));
      // dispatch(getLogLevel());
      // dispatch(getLiveJobList());
      // }
    }, 300000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  const appRender = (data) => {
    dispatch(getLogSnippet(100));
    setRender(data.value[0])
  };
 const isButtonDisabled = (value) => {
    // return value == "manage";
  };
  return (
    <Fragment>
      <Card
        className={"w-100 log-card"}
        style={{ overflow: "auto", height: "89vh", border: "none" }}
      >
        <Card.Body
          className={"log-content"}
          style={{ overflow: "hidden", padding: "0px" }}
        >
          {/* <Card className={"w-100 log-card"} style={{ boxShadow: "none",color: '#fff', border: 'none', overflow: 'auto' }}>
                <Card.Body className={"dashboard_content"} style={{ overflow: 'hidden', padding: '0px' }}> */}
          {/* <div className="col-md-12 logpage"> */}
          {/* <div className="col-md-12 d-flex p-0 m-0 logDetails">
                            <div className="col-md-2 log-menu"> */}
          <div
            className={"d-flex col-md-12 logDetails "}
            style={{
              backgroundColor: "#1e1e1e",
              borderRadius: "5px",
              padding: "0px",
            }}
          >
            {/* <div className={"col-md-2 log-menu"} style={{}}>
              <Box
                component={"legend"}
                className="col-md-12"
                style={{ top: "12px", paddingLeft: "0px", paddingRight: "0px" }}
              >
                {headerLogList.map((n,index) => (
                  <Button
                  key={index}
                   style={{
                        // backgroundColor: "#286685",
                        // backgroundColor: isButtonDisabled(n.value) ? "rgb(53 101 133 / 72%)" : "#286685",
                        backgroundColor: isButtonDisabled(n.value)
                          ? "rgb(53 101 133 / 72%)"
                          : render === n.value
                          ? "#242424" //"#154b6e"
                          : "#333333",
                        width: "100%",
                        color: "#fff",
                        margin: "5px 10px",
                        padding: "5px",
                        textTransform: "none",
                        height: "55px",
                        cursor: isButtonDisabled(n.value)
                          ? "not-allowed"
                          : "pointer",
                        borderBottom:
                          render === n.value ? "3px solid white" : "none",
                      }}
                    onClick={() => appRender({ value: [n.value] })}
                  >
                    <b style={{ fontSize: "14px !important" }}>{n.name}</b>
                  </Button>
                ))}
              </Box>
            </div> */}
            <div className="col-md-12  p-0 h-100" style={{}}>
              {/* <div className="col-md-10 logContent" style={{background:"#dcebfed9", padding: "15px"}} > */}
              <Card
                className={"shadow-none w-100 log-card1"}
                style={{
                  backgroundColor: "#333333",
                  padding: "15px",
                  overflow: "auto",
                  height: "89vh",
                  border: "none",
                  borderRadius: "unset",
                }}
              >
                {/* <Tooltip title="Download Log's" style={{width:"max-content", marginLeft: "auto"}}>
                  <IconButton
                    sx={{ color: "#000" }}
                    onClick={() => {
                      // dispatch(getDownloadJobs(row.original));
                    }}
                  >
                    <DownloadIcon />
                  </IconButton>
                </Tooltip> */}
                <Card.Body
                  className={"log_content"}
                  style={{
                    borderRadius: "0.25rem",
                    background: "#242424",
                    overflow: "hidden auto",
                    padding: "20px",
                  }}
                >
                  <p style={{color:"#c7c7c7", fontWeight:"600"}}>Logs: </p>
                  {/* <Paper style={{ height: "83vh", overflozwX:"hidden", overflowY:"auto", background:"white", padding:"20px", boxShadow: 'none'}}> */}
                  <code>
                    {logSnippet && typeof logSnippet === "string"
                      ? logSnippet
                          .replace(/\t/g, "    ")
                          .split("\n")
                          .join("\r\n")
                      : (<div className="no-logs-found">
                        <b>No Logs Found</b>
                      </div>)}
                  </code>
                </Card.Body>
              </Card>
              {/* </Paper> */}
            </div>
          </div>
          {/* </div> */}
        </Card.Body>
      </Card>
    </Fragment>
  );
};

export default LogList;
